/**
 * Vue Axios HTTP library
 */
import 'whatwg-fetch';
// abortcontroller polyfill for fetch is for wavesurfer audio visualisation
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch.js';

import axios from 'axios';

if (process.env.API_URL) {
    axios.defaults.baseURL = process.env.API_URL;
}
axios.defaults.crossDomain = false;
axios.defaults.withCredentials = true;

export const plugin = {
    name: 'axios',

    pluginProperties: {
        axios
    },

    install (Vue) {
        Vue.prototype.$axios = axios;
    }
};

export default plugin;
